import React from 'react';
import './Textarea.scss'


const Textarea = (props, ref) => {
    const classes = "Textarea " + props.className;
    const placeholder = props.placeholder;
    const onKeyDown = props.onKeyDown;
    const message = props.name;



    return (
        <textarea
        ref={ref}
        name={message}
        className={classes}
        placeholder={placeholder}
        onKeyDown={onKeyDown}
        >

        </textarea>
    );
}


const forwardRefTextarea = React.forwardRef(Textarea)
export default forwardRefTextarea;
